export const FETCH_GUIDES = 'GUIDES/FETCH';
export const SET_GUIDES = 'GUIDES/SET';
export const SET_GUIDES_IS_ERROR = 'GUIDES/SET_IS_ERROR';
export const SET_LOADING_STATE = 'GUIDES/SET_LOADING_STATE';

export const SET_IS_SHOW_GUIDES_NOTIFICATION = 'USER/SET_IS_SHOW_GUIDES_NOTIFICATION';
